import type { AssignableUser } from "@redotech/effect-api-shared/rpc/support-ticket-related-records";
import {
  AI_AGENT_ASSIGNEE_SENTINEL,
  supportTicketFilterData,
  SupportTicketFilterNames,
  UNASSIGNED_ASSIGNEE_SENTINEL,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import AssigneesIcon from "@redotech/redo-icons/user-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const userNameCache = new Map<string, string>();

export function createAssigneesAdvancedFilter(
  users: readonly AssignableUser[] | undefined,
): ArrayStringTableFilter<string> {
  return {
    type: AdvancedFilterType.ARRAY_TO_STRING,
    Icon: AssigneesIcon,
    operators: [
      ArrayStringFilterOperator.ANY_OF,
      ArrayStringFilterOperator.NONE_OF,
    ],
    data: supportTicketFilterData[SupportTicketFilterNames.ASSIGNEES],
    itemLabel: "assignee",
    itemLabelPlural: "assignees",
    displayName: "Assignees",
    dbSearch: true,
    valueFetcher: users
      ? async (_params, _signal) => {
          for (const u of users) {
            userNameCache.set(u._id, u.name);
          }
          return [
            UNASSIGNED_ASSIGNEE_SENTINEL,
            AI_AGENT_ASSIGNEE_SENTINEL,
            ...users.map((u) => u._id),
          ];
        }
      : undefined,
    display: (item: string) =>
      item === UNASSIGNED_ASSIGNEE_SENTINEL
        ? "Unassigned"
        : item === AI_AGENT_ASSIGNEE_SENTINEL
          ? "AI Agent"
          : (userNameCache.get(item) ?? item),
  };
}
